// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host footer {
  margin-top: 20px;
}
:host .container-footer {
  padding: 20px;
}
:host .container-footer span a {
  color: #233498;
}
:host .container-footer p {
  font-size: 12px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC1mb290ZXIuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0U7RUFDRSxnQkFBQTtBQUFKO0FBR0U7RUFDRSxhQUFBO0FBREo7QUFJTTtFQUNFLGNBQUE7QUFGUjtBQUtJO0VBQ0UsZUFBQTtBQUhOIiwiZmlsZSI6ImFwcC1mb290ZXIuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdCB7XG4gIGZvb3RlciB7XG4gICAgbWFyZ2luLXRvcDogMjBweDtcbiAgfVxuXG4gIC5jb250YWluZXItZm9vdGVyIHtcbiAgICBwYWRkaW5nOiAyMHB4O1xuXG4gICAgc3BhbiB7XG4gICAgICBhIHtcbiAgICAgICAgY29sb3I6ICMyMzM0OTg7XG4gICAgICB9XG4gICAgfVxuICAgIHAge1xuICAgICAgZm9udC1zaXplOiAxMnB4O1xuICAgIH1cbiAgfVxufVxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/layout/components/app-footer/app-footer.component.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;AAAJ;AAGE;EACE,aAAA;AADJ;AAIM;EACE,cAAA;AAFR;AAKI;EACE,eAAA;AAHN;AACA,wmBAAwmB","sourcesContent":[":host {\n  footer {\n    margin-top: 20px;\n  }\n\n  .container-footer {\n    padding: 20px;\n\n    span {\n      a {\n        color: #233498;\n      }\n    }\n    p {\n      font-size: 12px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
